


<template lang="jade">

	div.video-nav(
		v-if="$route.name === 'trailer'"
	)
		div.video-nav-prev(
			@click="prev"
		)
			i.icon-icon-arrow-left

		div.video-nav-close(
			@click="close"
		)
			i.icon-icon-close

		div.video-nav-next(
			@click="next"
		)
			i.icon-icon-arrow-right


</template>



<script>



	const $cmp = {
		name : 'video-nav',
		components : {}
	}



	$cmp.data = function() {
		return {}
	}



	$cmp.computed = {}

	$cmp.computed.prevPath = function() {

		let $this = this

		let films = $this.$store.pages.films.children
		let prevFilm = null

		let i = 0
		for (i=0; i < films.length; i++) {

			let film = films[i]

			if (film.slug === $this.$route.params.filmID) {
				prevFilm = films[i - 1]
			}

			if (!prevFilm) {
				prevFilm = films[films.length - 1]
			}

		}

		return '/films/' + prevFilm.slug + '/trailer'

	}

	$cmp.computed.nextPath = function() {

		let $this = this

		let films = $this.$store.pages.films.children
		let nextFilm = null

		let i = 0
		for (i=0; i < films.length; i++) {

			let film = films[i]

			if (film.slug === $this.$route.params.filmID) {
				nextFilm = films[i + 1]
			}

			if (!nextFilm) {
				nextFilm = films[0]
			}

		}

		return '/films/' + nextFilm.slug + '/trailer'

	}



	$cmp.mounted = function() {
		var $this = this
	}



	$cmp.methods = {}

	$cmp.methods.close = function() {
		let $this = this
		$this.$router.push({ path : '/films/' + $this.$route.params.filmID })
	}

	$cmp.methods.prev = function() {
		let $this = this
		$this.$router.push({ path : $this.prevPath })
	}

	$cmp.methods.next = function() {
		let $this = this
		$this.$router.push({ path : $this.nextPath })
	}



	export default $cmp



</script>



<style lang="stylus" scoped>

	.video-nav
		position absolute
		top 35px
		width 100%
		height 25px
		z-index 5

	.video-nav-prev
		position absolute
		top 0px
		left 30px
		cursor pointer

		i
			font-size 16px
			color #FFFFFF

	.video-nav-close
		position absolute
		top 0px
		left 50%
		transform translate(-50%,0%)
		color #FFFFFF
		cursor pointer

		i
			font-size 16px
			color #FFFFFF

	.video-nav-next
		position absolute
		top 0px
		right 30px
		cursor pointer

		i
			font-size 16px
			color #FFFFFF

</style>



// WEBPACK FOOTER //
// src/components/home/video-nav.vue